import { useEffect, useState } from "react";

const navLinks = [
  { href: "#recommend", label: "番剧推荐", icon: "ri-fire-line" },
  { href: "#catalog", label: "分类浏览", icon: "ri-layout-grid-line" },
  { href: "#movies", label: "剧场版 / OVA", icon: "ri-movie-2-line" },
  { href: "#region", label: "日漫与国漫", icon: "ri-earth-line" },
  { href: "#guide", label: "补番指南", icon: "ri-road-map-line" },
  { href: "#ranking", label: "排行榜", icon: "ri-bar-chart-2-line" },
  { href: "#faq", label: "常见问题", icon: "ri-question-line" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 border-b border-background-200/70 backdrop-blur"
          : "bg-transparent"
      }`}
    >
      <nav className="w-full px-4 md:px-8 h-16 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2 shrink-0 cursor-pointer">
          <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-flower-fill text-lg" aria-hidden="true"></i>
          </span>
          <span
            className={`font-heading text-lg font-bold tracking-wide ${
              scrolled ? "text-foreground-950" : "text-background-50"
            }`}
          >
            樱花动漫在线
          </span>
        </a>

        <div className="hidden lg:flex items-center gap-1">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`px-3 py-2 rounded-md text-sm whitespace-nowrap transition-colors ${
                scrolled
                  ? "text-foreground-700 hover:bg-primary-100 hover:text-primary-700"
                  : "text-background-100 hover:bg-white/15"
              }`}
            >
              {link.label}
            </a>
          ))}
        </div>

        <a
          href="#recommend"
          className="hidden lg:inline-flex items-center gap-2 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap transition-colors hover:bg-primary-600 cursor-pointer"
        >
          <i className="ri-play-circle-line text-base" aria-hidden="true"></i>
          开始追番
        </a>

        <button
          type="button"
          aria-label="打开菜单"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((v) => !v)}
          className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md ${
            scrolled ? "text-foreground-900" : "text-background-50"
          }`}
        >
          <i className={menuOpen ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"} aria-hidden="true"></i>
        </button>
      </nav>

      {menuOpen && (
        <div className="lg:hidden bg-background-50 border-b border-background-200 shadow-none">
          <div className="px-4 py-3 grid grid-cols-2 gap-2">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="flex items-center gap-2 px-3 py-2 rounded-md text-sm text-foreground-700 bg-background-100 hover:bg-primary-100 hover:text-primary-700 transition-colors"
              >
                <i className={link.icon} aria-hidden="true"></i>
                {link.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}